

const AddToCartNo = (state, action) => {

    const { shopping, totalPrice, qty } = state;
    // const { IsAdding, setIsAdding, } = action;

    let product;
    let index;
    let updatePrice;
    let updateQty;

    switch (action.type) {
        case "ADD_TO_CART":
            console.log("ADD_TO_CART");

            const check = shopping.find(product => product._id === action.id);
            if (check) {

                return state;
            } else {
                product = action.product;
                product['qty'] = 1;
                updateQty = qty + 1;
                updatePrice = totalPrice + product.price;
                return { shopping: [product, ...shopping], qty: updateQty, totalPrice: updatePrice };

            }
        // break;
        case "DELETE":
            const filter = shopping.filter(product => product._id !== action.id);
            product = action.product;
            updateQty = qty - product.qty;
            updatePrice = totalPrice - product.price * product.qty;
            return { shopping: [...filter], qty: updateQty, totalPrice: updatePrice };

        case "INC":
            product = action.product;
            product.qty = product.qty + 1;
            updatePrice = totalPrice + product.price;
            updateQty = qty + 1;
            index = shopping.findIndex(product => product._id === action.id);
            shopping[index] = product;
            return { shopping: [...shopping], qty: updateQty, totalPrice: updatePrice };

        case "DEC":
            product = action.product;
            if (product.qty > 1) {
                product.qty = product.qty - 1;
                updatePrice = totalPrice - product.price;
                updateQty = qty - 1;
                index = shopping.findIndex(product => product._id === action.id);
                shopping[index] = product;
                return { shopping: [...shopping], qty: updateQty, totalPrice: updatePrice };
            } else {
                // alert("You Have To Order At List One Items..");
                return state;

            }

        default:
            return state;

    };
};

export default AddToCartNo;